import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BriefcaseBusiness, Check, Compass, HeartHandshake, Network, Sparkles, Target, Users } from 'lucide-react';

export default function EventsImpactOverview() {
  return (
    <main className="pt-[72px] impact-overview">
      <section className="impact-hero">
        <div className="impact-aurora" />
        <div className="impact-grid-bg" />
        <div className="mx-auto grid max-w-[1200px] items-center gap-12 px-6 lg:grid-cols-2">
          <div className="impact-hero-copy">
            <h1>Faire avancer les projets.<br /><em>Faire se rencontrer les personnes.</em></h1>
            <p>Deux façons de créer de l'impact : structurer une activité avec méthode, ou réunir les bonnes personnes autour d'une expérience professionnelle utile.</p>
            <div>
              <a href="#deux-parcours" className="impact-primary">Découvrir les deux parcours <ArrowRight /></a>
              <Link to="/contact#contact-form">Parler de votre projet</Link>
            </div>
          </div>
          <div className="impact-motion" aria-hidden="true">
            <div className="impact-node impact-idea"><Target /><b>IDÉE</b></div>
            <div className="impact-node impact-method"><Compass /><b>MÉTHODE</b></div>
            <div className="impact-node impact-people"><Users /><b>CONNEXIONS</b></div>
            <div className="impact-core"><Sparkles /><b>IMPACT</b></div>
            <svg viewBox="0 0 500 430">
              <path d="M95 95 C190 45 245 180 260 210" />
              <path d="M410 95 C310 40 290 165 260 210" />
              <path d="M90 345 C180 400 235 280 260 210" />
            </svg>
            <i /><i /><i />
          </div>
        </div>
      </section>

      <section id="deux-parcours" className="impact-paths">
        <div className="mx-auto max-w-[1200px] px-6">
          <header><h2>Transformer une intention en résultat concret</h2></header>
          <div className="impact-path-grid">
            <article className="impact-strategy-card">
              <div className="impact-card-image"><img src="/assets/event2.jpg" alt="Séance d'accompagnement stratégique" /></div>
              <div>
                <Compass /><small>ACCOMPAGNEMENT STRATÉGIQUE</small>
                <h3>Clarifier, structurer et développer votre activité.</h3>
                <p>Pour les entrepreneurs, PME, dirigeants et organisations qui veulent mieux positionner leur offre, organiser leurs priorités, développer leurs ventes, créer des partenariats ou préparer un développement international.</p>
                <ul>{['Structuration et positionnement', 'Stratégie commerciale et méthodes de vente', 'Partenariats et développement'].map((x) => <li key={x}><Check />{x}</li>)}</ul>
                <Link className="impact-card-action" to="/accompagnement-evenements/accompagnement">Découvrir l'accompagnement <ArrowRight /></Link>
              </div>
            </article>
            <article className="impact-network-card">
              <div className="impact-card-image"><img src="/assets/event3.jpg" alt="Événement professionnel et networking" style={{ objectPosition: 'center top' }} /></div>
              <div>
                <Network /><small>TEAM BULDING & NETWORKING</small>
                <h3>Connecter les talents, les entreprises et les opportunités.</h3>
                <p>Pour créer des rencontres professionnelles à forte valeur : networking entrepreneurial, emploi, entrepreneuriat féminin, conférences, ateliers, séminaires et événements partenaires.</p>
                <ul>{['Rencontres entreprises–jeunes talents', 'Conférences, ateliers et séminaires', 'Événements partenaires et communautés'].map((x) => <li key={x}><Check />{x}</li>)}</ul>
                <Link className="impact-card-action" to="/accompagnement-evenements/networking">Découvrir le Team Bulding & networking <ArrowRight /></Link>
              </div>
            </article>
          </div>
        </div>
      </section>

      <section className="impact-bridge">
        <div className="mx-auto max-w-[1100px] px-6">
          <div className="impact-bridge-visual"><span><BriefcaseBusiness /></span><i /><b><HeartHandshake /></b><i /><span><Users /></span></div>
          <h2>De la stratégie à la rencontre, puis de la rencontre à l'opportunité.</h2>
          <p>L'accompagnement peut préparer un projet à mieux se présenter. L'événement peut ensuite lui permettre de rencontrer des partenaires, des clients, des talents ou une communauté. Les deux parcours peuvent vivre séparément ou se compléter.</p>
        </div>
      </section>

      <section className="impact-choice">
        <div className="mx-auto max-w-[1050px] px-6">
          <header><h2>Partez de votre besoin actuel</h2></header>
          <div>
            <Link to="/accompagnement-evenements/accompagnement"><Compass /><span><b>J'ai besoin de clarté et d'une méthode</b><small>Structurer mon offre, mes priorités, ma stratégie ou mon développement.</small></span><ArrowRight /></Link>
            <Link to="/accompagnement-evenements/networking"><Network /><span><b>J'ai besoin de créer une rencontre et des connexions</b><small>Imaginer un événement, réunir une communauté ou activer un partenariat.</small></span><ArrowRight /></Link>
            <Link to="/accompagnement-evenements/accompagnement"><Compass /><span><b>J’ai besoin de clarté et d’une méthode</b><small>Structurer mon offre, mes priorités, ma stratégie ou mon développement.</small></span><ArrowRight /></Link>
            <Link to="/talents-rh/academy"><Network /><span><b>Je souhaite organiser une formation</b><small>Choisir les thèmes, le format et demander un devis.</small></span><ArrowRight /></Link>
            <Link to="/accompagnement-evenements/networking"><Network /><span><b>J’ai besoin de créer une rencontre et des connexions</b><small>Imaginer un événement, réunir une communauté ou activer un partenariat.</small></span><ArrowRight /></Link>
          </div>
        </div>
      </section>
    </main>
  );
}
